<template>
  <span
    v-if="isDraw"
    v-on:click="processOdd"
    :class="[
      'bto-sb-event-odd',
      'bto-sb-event-odd-x',
      { 'bto-sb-event-odd-active': isOddSelected },
      combiClass,
      quickBetClasses,
      { 'bto-sb-odd-lock': checkSuspended() },
    ]">
    <span
      v-if="getQuickBetNotification && getQuickBetNotification.betslip.status === 4"
      class="bto-sb-spinner-v1"></span>
    <i>{{ t("Mobile.outcomexname") }}</i>
    <i>{{ outcome.originalDecimalOutcome | formatOddDisplay(this.$root.oddFormat) }}</i>
  </span>

  <span
    v-else
    v-on:click="processOdd"
    :class="[
      'bto-sb-event-odd',
      { 'bto-sb-event-odd-active': isOddSelected },
      combiClass,
      quickBetClasses,
      { 'bto-sb-odd-lock': checkSuspended() },
    ]">
    <span
      v-if="getQuickBetNotification && getQuickBetNotification.betslip.status === 4"
      class="bto-sb-spinner-v1"></span>
    <span class="bto-sb-event-team">
      <logo-component v-if="teamIcon" v-slot="{ url, reset, onLoad, loaded }" :logo-url="teamIcon" >
        <span class="bto-sb-event-team-logo bto-sb-event-hometeam-logo" v-if="url" v-show="loaded">
          <img :src="url" alt="" @error="reset" @load="onLoad" />
        </span>
      </logo-component>
      <i>{{ teamName }}</i>
      <i>{{ outcome.originalDecimalOutcome | formatOddDisplay(this.$root.oddFormat) }}</i>
    </span>
    <span v-if="eventDescription !== ''" class="bto-sb-event-description">
      {{ eventDescription }}
    </span>
  </span>
</template>

<script>
  import { toggleItem, toggleAlgoItem, isOddActive, getQuickbetPlacementMessage, placeQuickBet } from '@bto-services/betslip-core';
  import { mapMatchToBetslipItem, mapMatchToBetslipMatchItem, getQuickBetClass } from 'bto-models/betslip';
  import { showBetslipValidation } from '@bto-services/modal';

  export default {
    name: 'MatchExpandedOddComponent',
    data() {
      return {};
    },
    props: {
      item: {
        type: Object,
        default: () => { },
      },
      odd: {
        type: Object,
        default: () => { },
      },
      outcome: {
        type: Object,
        default: () => { },
      },
      teamIcon: {
        type: String,
        default: '',
      },
      teamName: {
        type: String,
        default: '',
      },
      eventDescription: {
        type: String,
        default: '',
      },
      isDraw: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      isOddSelected() {
        return isOddActive({
          matchId: this.item.matchId,
          outcomeId: this.outcome.id,
          marketId: this.odd.marketId,
        });
      },
      combiClass() {
        if (typeof this.odd !== 'object') {
          return null;
        }
        switch (this.odd.isCombo) {
          case 2:
            return 'bto-sb-combomini';
          case 3:
            return 'bto-sb-combomini3';
          case 4:
            return 'bto-sb-combomini4';
          case 5:
            return 'bto-sb-combomini5';
        }
        return null;
      },
      getQuickBetNotification() {
        return getQuickbetPlacementMessage({
          matchId: this.item.matchId,
          outcomeId: this.outcome.id,
          marketId: this.odd.marketId,
        });
      },
      quickBetClasses() {
        return getQuickBetClass(this.getQuickBetNotification);
      },
    },
    methods: {
      /**
       * Handle odd click
       */
      processOdd() {
        if (this.outcome.originalDecimalOutcome === '--' || this.outcome.id === 0 || this.checkSuspended()) {
          return;
        }
        const betslip_item = mapMatchToBetslipItem(
          this.item,
          this.outcome,
          this.odd,
          false,
          true);
        const betslipMatchItem = mapMatchToBetslipMatchItem(this.item, false);
        const error = toggleAlgoItem(betslip_item, betslipMatchItem);
        showBetslipValidation(error);
        if (this.isOddSelected) {
          placeQuickBet(betslip_item);
        }
      },
      /**
       * Check "suspended" status
       */
      checkSuspended() {
        return this.item.suspended || this.outcome.suspended;
      },
    },
  };
</script>
